<!--
 * @Author       : 花裤衩(BYM)<yongming.bai@outlook.com>
 * @Date         : 2024-09-05 15:39:58 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-06-30 16:53:00 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/icon/src/izt-icon.vue
 * @Description  : icon组件
-->
<template>
  <i :class="[fontFamily, ...classFilter]" v-if="classFilter.length" :style="{ fontSize: computedSize, color: fill }"></i>
  <svg v-else :fill="fill" :width="computedSize" :height="computedSize" aria-hidden="true">
    <use :xlink:href="`#${name}`"></use>
  </svg>
</template>

<script setup name="izt-icon">
  import { computed } from 'vue'
  defineOptions({ name: 'izt-icon' })
  const props = defineProps({
    fill: { type: String, default: 'auto' }, // 图标颜色
    fontFamily: { type: String, default: 'agent-family' }, // 图标库名称 默认 agent-family
    name: { type: String, default: '' }, // 图标名称
    size: { type: [Number, String], default: 24 }, // 图标大小
    className: { type: [String, Array], default: () => ([]) } // 自定义图标样式
  });

  const classFilter = computed(() => {
    // 判断是否为数组
    if (Array.isArray(props.className)) {
      return props.className
    } else {
      return [props.className]
    }
  })

  // px 转 rem 工具函数
  const pxToRem = (px, base = 75, keepUnit = true) => {
    if (typeof px === 'string') {
      if (px === 'auto' || px.includes('%') || px.includes('rem')) return px
      px = parseFloat(px.replace('px', ''))
    }
    const remValue = px / base
    return keepUnit ? `${remValue.toFixed(3)}rem` : Number(remValue.toFixed(3))
  }

  // 计算后的 size（用于 fontSize / width / height）
  const computedSize = computed(() => {
    const size = typeof props.size === 'number' || (typeof props.size === 'string' && props.size.includes('px')) ? pxToRem(props.size) : props.size
    return size
  });
</script>